import type { ConsentFormState } from '@/types/consent';

export type TermsReturnState = {
  form: ConsentFormState;
};

function isConsentFormState(value: unknown): value is ConsentFormState {
  if (!value || typeof value !== 'object') {
    return false;
  }
  const record = value as Record<string, unknown>;
  return (
    typeof record.acceptedTerms === 'boolean' &&
    typeof record.acceptedPrivacy === 'boolean' &&
    typeof record.acceptedMarketing === 'boolean'
  );
}

export function isTermsReturnState(value: unknown): value is TermsReturnState {
  if (!value || typeof value !== 'object') {
    return false;
  }
  const record = value as Record<string, unknown>;
  return isConsentFormState(record.form);
}

export function parseTermsNavigationState(state: unknown): ConsentFormState | null {
  if (isTermsReturnState(state)) {
    return state.form;
  }
  return null;
}
